import { render } from "./SystemAccounts.vue?vue&type=template&id=5460c888&ts=true"
import script from "./SystemAccounts.vue?vue&type=script&lang=ts"
export * from "./SystemAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__